var exports = {
  "w": "Section___hrvNf",
  "y": "divider__AUukiQ",
};

module.exports = exports;
